import React from 'react';

import { useCommon } from '../../store/CommonContext';
import { PRIMARY_COLOR } from '../constants/style-constants';

import './ListItem.css';

interface Props {
  children: React.ReactElement | string | null;
  removeBottomMargin?: boolean;
  additionalClasses?: string;
}

const ListItem: React.FC<Props> = props => {
  const { children, removeBottomMargin, additionalClasses } = props;
  const {
    state: { configuration },
  } = useCommon();

  return (
    <li
      className={`ui-widget-list-item ${removeBottomMargin ? 'no-bottom-margin' : ''} ${additionalClasses}`}
      style={{
        ...(typeof configuration?.primaryColor === 'string' && { color: configuration.primaryColor }),
      }}
    >
      {children}
    </li>
  );
};

export default ListItem;
